<template>
  <Content id="taskDetails">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名" :label-width="45"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleTaskChange(item)" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem  label="学校" prop="schoolId">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" @change="changeSchool" style="width: 100%;" >
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId">
              <el-select v-model.trim="search.gradeId" placeholder="年级" clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" @change="changeGrade" style="width: 100%;">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true" style="width: 100%;" :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width:100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="常规体检" :label-width="75">
              <Select v-model="search.conventional" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in conventionalList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="常规加项" :label-width="75">
              <Select v-model="search.convOptionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in convOptionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          -->
          <Col>
            <FormItem label="抽血体检" :label-width="75">
              <Select v-model="search.bloodDraw" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in bloodDrawList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血加项" :label-width="75">
              <Select v-model="search.optionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in optionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检类型" :label-width="75">
              <Select v-model="search.type" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in typeList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="报名状态"  prop="signUpStatus" :label-width="75">
              <Select v-model="search.signUpStatus" style="width:100%;min-width: 110px;" :clearable="true">
                <Option v-for="item in signUpStatusList" :value="item.code" v-bind:key="item.code" style="width:100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="报名方式"  prop="source" :label-width="75">
              <Select v-model="search.source" style="width:100%;min-width: 110px;" :clearable="true">
                <Option v-for="item in sourcesList" :value="item.code" v-bind:key="item.code" style="width:100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>

    <Row>
      <div style="margin-top: 5px;width: 100%;">
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">新增</Button>
          <Button size="small" style="margin-left: 5px;" @click="handleImportClick('1')" type="primary">导入名单</Button>
<!--        <Button size="small" style="margin-left: 5px;" @click="handleImportClick('2')" type="primary">导入中小学</Button>-->
          <Button size="small" style="margin-left: 5px;" @click="batchExport" type="primary">批量导出</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchAudit" type="primary">批量审核</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchDel" type="error">批量删除</Button>
        </div>
      </div>
    </Row>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" @selection-change="selectList" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" type="selection" width="30"/>
      <el-table-column fixed="left" align="center" prop="taskName" label="体检任务名称" min-width="200"/>
      <el-table-column fixed="left" align="center" prop="name" label="姓名" min-width="100"/>
      <el-table-column fixed="left" align="center" prop="gender" label="性别" min-width="80">
        <template slot-scope="{row}">{{ row.gender === 1 ? '男' : row.gender === 2 ? '女' :  '' }}</template>
      </el-table-column>
      <el-table-column fixed="left" align="center" prop="idCard" label="证件号码" min-width="180"/>
      <el-table-column align="center" prop="idCardType" label="证件类型" min-width="150">
        <template slot-scope="{row}">{{  convertIdCardTypes(row.idCardType) }}</template>
      </el-table-column>
      <el-table-column align="center" prop="birthday" label="出生日期" min-width="110"/>
      <el-table-column align="center" prop="phone" label="手机号码" min-width="130"/>
      <el-table-column align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" min-width="110"/>
      <el-table-column align="center" prop="classesName" label="班级" min-width="160"/>
      <el-table-column align="center" prop="physicalPackage" label="基础体检套餐" min-width="200"/>
      <el-table-column align="center" prop="physicalProject" label="自选项目" min-width="250"/>
      <el-table-column align="center" prop="barCode" label="条形码" min-width="130">
        <template slot-scope="{row}">
          <el-tag size="small" type="danger" disable-transitions v-if="row.signUpStatus === 1">待审核生成</el-tag>
          <span v-if="row.signUpStatus !== 1">{{ row.barCode }}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column align="center" prop="convOptionsStatus" label="常规加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.convOptionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.convOptionsStatus === 1 ? '无加项' : row.convOptionsStatus === 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      -->
      <el-table-column align="center" prop="optionsStatus" label="抽血加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.optionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.optionsStatus == 1 ? '无加项' : row.optionsStatus == 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="source" label="报名方式" min-width="150">
        <template slot-scope="{row}">{{  convertSource(row.source) }}</template>
      </el-table-column>
      <el-table-column align="center" prop="signUpStatus" label="报名状态"  min-width="90">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.signUpStatus === 2 ? 'primary' : row.signUpStatus === 3 ? 'warning' : 'danger'" disable-transitions>
            {{ row.signUpStatus === 2 ? '已审核' : row.signUpStatus === 3 ? '变动待审核' : '待审核' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="体检类型" min-width="130">
        <template slot-scope="{row}">
          {{ row.type == 1 ? '只做常规,不抽血' : row.type == 2 ? '只抽血,不做常规' : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bloodTubeRemark" label="试管" min-width="100"/>
      <el-table-column align="center" prop="remark" label="备注" min-width="100"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="90">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="detail(row)">{{ row.signUpStatus===2?'详情':'审核'}}</el-button>
          <el-button type="text" size="medium" @click="del(row)" style="color: red;" v-if="row.signUpStatus != 2">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="80%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <TaskDetailEdit ref="edit"  :style="{'max-height':maxHeight, 'overflow-y':'auto'}" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button @click="editWindow = false" v-if="showButton || auditButton">取消</Button>
        <Button type="primary" @click="submit" v-show="showButton">确认</Button>
        <Button type="primary" @click="submit" v-show="auditButton">审核</Button>
      </div>
    </Modal>

    <el-dialog :title="importTitle" :visible.sync="importWindow" width="400px" custom-class="my-dialog"
               :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-upload ref="refUpload" action="#" :limit="1" class="upload-demo" drag multiple :auto-upload="false"
                 :on-change="handleChange" :on-remove="handleRemove"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传ecel文件，且不超过500kb</div>
      </el-upload>
      <div>
        <a @click.stop="template()" v-if="importModel === '1'">文件模版</a>
        <a @click.stop="secondaryPrimaryTemplate()" v-if="importModel === '2'">文件模版</a>
      </div>

      <span slot="footer" class="dialog-footer">
          <el-button  @click="handleCancle">取 消</el-button>
          <el-button type="primary" @click="handleUpload" :disabled="importDisabled">确 定</el-button>
        </span>
    </el-dialog>

  </Content>
</template>
<script>
import {_page, _batchAudit, _upload, _secondaryPrimary, _template, _secondaryPrimaryTemplate, _batchExport, _delete} from "@/services/taskDetail/taskDetail";
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import TaskDetailEdit from "./TaskDetailEdit";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "TaskDetail",
  mixins: [mixins],
  components: {
    TaskDetailEdit,
  },
  computed: {

  },
  data() {
    return {
      search: {
        taskId:"",
        name:"",
        idCard:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        source:"",
        conventional:"",
        bloodDraw:"",
        type:"",
        signUpStatus:"",
        convOptionsStatus:"",
        optionsStatus:"",
        barCode:"",
        ids:""
      },
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex: null,
      enums:enums,
      fileList:[],
      importTitle:"",
      importWindow:false,
      importDisabled:false,
      importModel:"1",
      ids:[],
      showButton:true,
      auditButton:false,
      editWindow:false,
      windowTitle:"新增体检名单",
      gradeList:[],
      classesList:[],
      sourcesList:[
        {name: '全部', code: ''},
        {name: 'PC端', code: 1},
        {name: '小程序端', code: 2},
        {name: '导入', code: 3},
        {name: '自主填报', code: 4},
      ],
      signUpStatusList:[
        {name: '全部', code: ''},
        {name: '待审核', code: 1},
        {name: '已审核', code: 2},
        {name: '变动待审核', code: 3},
      ],
      convOptionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
      optionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
      conventionalList:[
        {label: '全部', value: ''},
        {label: '体检', value: 1},
        {label: '不体检', value: 2},
      ],
      bloodDrawList:[
        {label: '全部', value: ''},
        {label: '抽血', value: 1},
        {label: '不抽血', value: 2},
      ],
      typeList:[
        {label: '全部', value: ''},
        {label: '只做常规,不抽血', value: 1},
        {label: '只抽血,不做常规', value: 2},
      ],
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.applyTaskList();
      this.applySchoolsList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 305}px`;
      this.maxHeight = `${height - 305}px`;
    },
    convertSource(source){
      if(source === 1){
        return "pc系统";
      }else if(source === 2){
        return "导入";
      }else if(source === 3){
        return "自主填报";
      }
    },
    convertIdCardTypes(idCardTypes){
      if(idCardTypes === 1){
        return "居民身份证";
      }else if(idCardTypes === 2){
        return "儿童无身份证件";
      }else if(idCardTypes === 3){
        return "护照";
      }else if(idCardTypes === 4){
        return "港澳居民身份证";
      }else if(idCardTypes === 5){
        return "台湾居民来往内地通行证";
      }else if(idCardTypes === 6){
        return "其他法定有效证件";
      }else if(idCardTypes === 3){
        return "";
      }
    },
    changeSchool(schoolId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data){
          this.gradeList = res.data;
        }else{
          this.gradeList =[]
        }
      })
    },
    changeGrade(gradeId){
      if(!gradeId){
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId : gradeId}).then(res=>{
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data){
          this.classesList = res.data;
        }else{
          this.classesList =[]
        }
      })
    },
    handleTaskChange(item) {
      this.search.taskId = item.id;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.id;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
    },
    template(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      _template().then(res => {}).catch(error => {});
    },
    secondaryPrimaryTemplate(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      _secondaryPrimaryTemplate().then(res => {}).catch(error => {});
    },
    batchExport(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务")
        return;
      }

      if(this.ids && this.ids.length > 0){
        this.search.ids = this.ids.toString();
      }

      _batchExport(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.ids = [];
          this.search.ids = "";
        }else{
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {});
    },
    batchAudit(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务")
        return;
      }

      if(this.ids && this.ids.length > 0){
        this.search.ids = this.ids.toString();
      }

      this.$confirm('<h3>是否确定执行批量审核?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _batchAudit(this.search).then(res=>{
          if (res && res.errcode && res.errcode === 1){
            this.ids = [];
            this.search.ids = "";
            this.handleDataList();
            this.$message.success("审核成功")
          }else{
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});

    },
    batchDel(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning('请先选择体检任务!');
        return;
      }

      this.$confirm('<h3>删除后不可恢复, 是否确定批量删除?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        _delete({taskId:this.search.taskId, detailedIds:this.ids}).then(res => {
          if (res && res.errcode && res.errcode === 1){
            this.ids = [];
            this.search.ids = "";
            this.handleDataList();
            this.$message.success("删除成功")
          }else{
            this.$Message.error(res.errmsg);
          }
        }).catch(error => {
          this.$Message.error(res.errmsg);
        });
      }).catch(() => {});

    },
    handleImportClick(command){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.fileList = [];
      this.importModel = command;
      if(command === "1"){
        this.importTitle = "导入体检名单";
      }else  if(command === "2"){
        this.importTitle = "导入(中小学生)体检名单";
      }
      this.importWindow = true;
    },
    handleChange(file, fileList){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.importDisabled = false;
      this.$nextTick(() => {
        this.$refs.refUpload.clearFiles();
      });
    },
    handleCancle() {
      this.fileList = [];
      this.importWindow = false;
      this.importDisabled = false;
      this.$nextTick(() => {
        this.$refs.refUpload.clearFiles();
      });
    },
    handleUpload(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }else if(!this.fileList || this.fileList.length === 0){
        this.$message.warning('请先选择需要上传的文件');
        return;
      }

      if(this.importModel === "1"){
        this.upload(this.fileList[0].raw);
      }else if(this.importModel === "2"){
        this.secondaryPrimary(this.fileList[0].raw);
      }
    },
    upload(file){
      this.importDisabled = true;

      _upload({file: file}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;
          this.$message.success("上传成功");
          this.handleDataList()
        } else if(res){
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 10000,
            center: true
          });
        }
      }).catch(res=>{
        this.importDisabled = false;
        /*this.$message({
          type: 'error',
          message: "上传失败",
          duration: 10000,
          center: true
        });*/
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    secondaryPrimary(file){
      this.importDisabled = true;

      _secondaryPrimary({file: file}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;
          this.$message.success("上传成功");
          this.handleDataList();
        } else{
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 10000,
            center: true
          });
        }
      }).catch(() => {
        this.importDisabled = false;
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.handleDataList();
    },
    handleDataList() {
      this.ids = [];
      this.search.ids = "";

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleModal(windowTitle, row) {
      this.windowTitle = windowTitle;
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.showButton = true;
      this.auditButton = false;
      this.handleModal("新增体检名单");
    },
    detail(row) {
      this.showButton = false;
      this.auditButton = row.signUpStatus !== 2 ? true : false;
      this.handleModal(row.signUpStatus===2?'体检名单详情':'体检名单审核', row);
    },
    del(row){
      let _this = this;
      this.$confirm('<h3>删除后不可恢复, 是否确定删除该学生报名?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        let detailedIds = [row.id];
        _delete({taskId:row.taskId, detailedIds:detailedIds}).then(res => {
          if (res && res.errcode && res.errcode === 1){
            this.$message.success("删除成功")
            _this.handleDataList();
          }else{
            this.$Message.error(res.errmsg);
          }
        }).catch(error => {
          this.$Message.error(res.errmsg);
        });
      }).catch(() => {});
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      /*if (row.row.signUpStatus && row.row.signUpStatus === 1) {
        return 'warning-row';
      }*/

      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectList(e){
      this.ids = [];
      e.forEach(item=>{
        this.ids.push(item.id)
      })
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ .ivu-table .success-row td{background: #beffc5;color: #101010;}
/deep/ .el-table__body tr.warning-row>td.el-table__cell{background: rgba(202, 138, 138, 0.4);color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
table thead th {background: #f5f5f5;padding: 10px;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}

</style>
